var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcoImpact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "198.36 202.855 21.798 23.92",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.09,
    y1: 12,
    x2: 22.91,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32a404"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.73,5.09A19.15,19.15,0,0,1,20,13.41,13.78,13.78,0,0,1,14.86,18a17.73,17.73,0,0,1-5.67,1.65,26,26,0,0,1-4.14.1c0-.11.53-2.47.55-2.61.11-.54.24-1.08.39-1.59a15.09,15.09,0,0,1,1.24-3A13.2,13.2,0,0,1,9.16,9.84l.08-.09c0-.08,0-.07-.05-.06h0c-4.23,3-5.79,8.21-6.08,13.27a1,1,0,0,1-1.12,1,1,1,0,0,1-.87-1.06l.16-2.19c.09-.66.2-1.33.34-2h0C.85,14.45.67,10.08,3.17,5.86A10.58,10.58,0,0,1,9.81,1c3.54-.91,6,.06,9.56-.37A15.32,15.32,0,0,0,21.44.14,1,1,0,0,1,22.86,1,20,20,0,0,1,22.73,5.09Z",
    transform: "matrix(1, 0, 0, 1, 197.248138, 202.807693)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoImpact);
export default __webpack_public_path__ + "static/media/EcoImpact.ebea388d26321c66799410a1f92b7837.svg";
export { ForwardRef as ReactComponent };